import React from "react";
import AddToCartButton from "../AddToCartButton/AddToCartButton";
import { useNavigate } from "react-router-dom";

export default function Payremaning({
  courseId,
  levelId,
  courseTitle,
  currency="$",
  amount,
  levelbadge,
  disabled,
  onClick,
}) {
  // console.log(courseId, levelId, courseTitle, amount, levelbadge);
     const navigate = useNavigate(); // if not already defined

  const handleClick = (e) => {

  if (disabled) {
    e.preventDefault();
    e.stopPropagation();
    
    // Show alert, then redirect after user clicks OK
    alert("Please complete your profile first!");
    navigate("/registerprofile"); // redirect to profile page
    return;
  }
  // Call parent onClick if provided
  if (onClick) onClick(e);
};

  return (
    <div
      className="reserve-container"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        cursor: "pointer",
      }}
    >
      <AddToCartButton
        courseId={courseId}
        levelId={levelId}
        courseTitle={courseTitle}
        amount={amount}
        levelbadge={levelbadge}
        currency={currency}
        mode="full"
        asLink={true}
        className="reserve-link"
        onClick={(e) => handleClick(e)}
      >
        Pay Remaining
      </AddToCartButton>
    </div>
  );
}
